import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './TooltipTab.scss';

export default class TooltipTab extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
  };
  static defaultProps = {
    tooltip: '',
  };
  render() {
    const { title, tooltip } = this.props;
    return (
      <React.Fragment>
        <p
          className="nf-solicitation_grid_header-tooltip"
          data-tip={tooltip}
          data-for={`tab-tooltip-${title}`}
        >
          {title}
        </p>
        <ReactTooltip
          id={`tab-tooltip-${title}`}
          type="dark"
          effect="float"
          delayShow={500}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/subComponents/ToolTipTab/ToolTipTab.jsx